import TalentosActions from "./TalentosActions";

const TalentoRow = ({ talento }) => {
  const isActive = talento.is_active;

  return (
    <tr>
      <td>
        <span className="text-md fw-medium text-primary-light">
          {talento.nombre}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            isActive
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {isActive ? "Activo" : "Inactivo"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <TalentosActions talento={talento} />
        </span>
      </td>
    </tr>
  );
};

export default TalentoRow;
